import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import get from "lodash/get";
import isArray from "lodash/isArray";
import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import defaultConfig from "./defaults/defaultConfig.json";
import substituteParametersValues from "./load-config";
export function loadAndMergeConfiguration(config) {
  var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return loadConfiguration(config, params, defaultConfig);
}
export function loadConfiguration() {
  var config = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    baseConfig = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : defaultConfig;
  return baseConfig && (config = mergeWith(baseConfig, config, function (target, src) {
    if (isArray(target) && isArray(src)) return src;
  })), setConfiguration(config = substituteParametersValues(config, params)), config;
}
var CONFIG_DATA_KEY = _Symbol("jutro.config.data");
export default function getConfiguration() {
  return global[CONFIG_DATA_KEY];
}
export function setConfiguration(config) {
  global[CONFIG_DATA_KEY] = function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }({}, config);
}
export function resolveValue(value) {
  var parsedValue = function (value) {
    if ("true" === value) return !0;
    if ("false" === value) return !1;
    return value;
  }(value);
  return parsedValue;
}
export function getConfigValue(path, defaultValue) {
  var _envVariable,
    value = null,
    envVariable = ("undefined" != typeof __FULL_ENV__ ? __FULL_ENV__ : null) || process.env;
  if (value = null !== (_envVariable = envVariable["REACT_APP_".concat(path.replace(/\./g, "_"))]) && void 0 !== _envVariable ? _envVariable : envVariable[path]) return resolveValue(value);
  var config = getConfiguration();
  return void 0 === (value = get(config, path)) ? defaultValue : resolveValue(value);
}
export function getAndExtendConfigValue(path, extension) {
  var configValue = getConfigValue(path);
  return merge(configValue, extension);
}
export function isFeatureEnabled(path) {
  var allEnabled = getConfigValue("feature.all", !0);
  return getConfigValue("feature.".concat(path), allEnabled);
}